export class PendingOrdersData {
    public consultantTotal: number;
    public consultantBuckets: number;
    public officeTotal: number;
    public officeBuckets: number;

    constructor(consultantTotal: number, consultantBuckets: number, officeTotal: number, officeBuckets: number) {
        this.consultantTotal = consultantTotal;
        this.consultantBuckets = consultantBuckets;
        this.officeTotal = officeTotal;
        this.officeBuckets = officeBuckets;
    }
}

export class PendingOrdersExtendedData {
    public consultantTotal: number;
    public consultantBuckets: number;
    public officeTotal: number;
    public officeBuckets: number;
    public consultantBucketPermanent: number;
    public consultantBucketTEA: number;
    public officeBucketPermanent: number;
    public officeBucketTEA: number;
    public consultantNoBucketPermanent: number;
    public consultantNoBucketTEA: number;
    public officeNoBucketPermanent: number;
    public officeNoBucketTEA: number;

    constructor(consultantBucketPermanent: number, consultantBucketTEA: number,
        officeBucketPermanent: number, officeBucketTEA: number,
        consultantNoBucketPermanent: number, consultantNoBucketTEA: number,
        officeNoBucketPermanent: number, officeNoBucketTEA: number) {

        this.consultantTotal = consultantBucketPermanent + consultantBucketTEA + consultantNoBucketPermanent + consultantNoBucketTEA;
        this.consultantBuckets = consultantBucketPermanent + consultantBucketTEA;
        this.officeTotal = officeBucketPermanent + officeBucketTEA + officeNoBucketPermanent + officeNoBucketTEA;
        this.officeBuckets = officeBucketPermanent + officeBucketTEA;

        this.consultantBucketPermanent = consultantBucketPermanent;
        this.consultantBucketTEA = consultantBucketTEA;
        this.officeBucketPermanent = officeBucketPermanent;
        this.officeBucketTEA = officeBucketTEA;
        this.consultantNoBucketPermanent = consultantNoBucketPermanent;
        this.consultantNoBucketTEA = consultantNoBucketTEA;
        this.officeNoBucketPermanent = officeNoBucketPermanent;
        this.officeNoBucketTEA = officeNoBucketTEA;
    }
}